/* eslint-disable no-useless-concat */
import { ApexOptions } from "apexcharts";
import { CustomerCardDataProps, GrossCategoriesType } from "../../../Types/DashboardsType";
import { TableColumn } from "react-data-table-component";
import { FormGroup, Input, Label } from "reactstrap";
import { Btn, H6, Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import { Link } from "react-router-dom";

export const monthlyDropdownList = ['Weekly', 'Monthly', 'Yearly'];

//charts
const incomeOption: ApexOptions = {
    series: [
        {
            name: 'series2',
            data: [15, 25, 20, 35, 60, 30, 20, 30, 20, 35, 25, 20],
        },
    ],
    colors: ["#008dab", "#e87f24"],
    chart: {
        height: 95,
        type: 'bar',
        sparkline: {
            enabled: true,
        },
    },
    tooltip: {
        enabled: false
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        curve: 'smooth',
    },
    plotOptions: {
        bar: {
            borderRadius: 3,
            distributed: true,
            columnWidth: "50%",
            barHeight: '38%',
            dataLabels: {
                position: 'top',
            },
        }
    },
    responsive: [
        {
            breakpoint: 1700,
            options: {
                chart: {
                    height: 86,
                },
            },
        },
        {
            breakpoint: 1699,
            options: {
                chart: {
                    height: 95,
                },
            },
        },
        {
            breakpoint: 1460,
            options: {
                grid: {
                    padding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 5,
                    },
                },
            },
        },
        {
            breakpoint: 376,
            options: {
                chart: {
                    height: 50,
                },
            },
        },
    ],
};

const expenseOptions: ApexOptions = {
    series: [{
        name: "Desktops",
        data: [50, 50, 50, 25, 25, 25, 2, 2, 2, 25, 25, 25, 62, 62, 62, 35, 35, 35, 66, 66],
    }],
    chart: {
        height: 100,
        type: 'area',
        zoom: {
            enabled: false
        },
        toolbar: {
            show: false,
        },
        dropShadow: {
            enabled: true,
            top: 5,
            left: 0,
            blur: 2,
            color: '#008dab',
            opacity: 0.2,
        },
    },
    colors: ["#008dab"],
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 0.1,
            stops: [0, 90, 100]
        }
    },
    tooltip: {
        enabled: false
    },
    dataLabels: {
        enabled: false
    },
    grid: {
        show: false,
    },
    xaxis: {
        labels: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        show: false,
    },
    stroke: {
        curve: 'straight',
        width: 2,
    },
    markers: {
        discrete: [{
            seriesIndex: 0,
            dataPointIndex: 12,
            fillColor: '#008dab',
            strokeColor: '#fff',
            size: 5,
            shape: "circle"
        }],
    }
};

//datas

export const totalEarningCardsData = [
    {
        id: 1,
        title: 'Total Earning',
        rate: '20.790',
        lastWeek: 16.06,
        chart: {
            ...incomeOption,
            series: incomeOption.series,
            type: incomeOption.chart?.type,
        },
    },
    {
        id: 2,
        title: 'Total Expense',
        rate: '4683.90',
        lastWeek: 10.34,
        chart: {
            ...expenseOptions,
            series: expenseOptions.series,
            type: expenseOptions.chart?.type
        }
    },
];

export const customerCardData: CustomerCardDataProps[] = [
    {
        id: 1,
        divClass: 'col-xxl-3 col-xl-50 col-sm-6 proorder-xl-2',
        color: 'primary',
        title: 'Customers',
        rate: '1.485',
        icon: 'male',
        percent: 4.6
    },
    {
        id: 2,
        divClass: 'col-xxl-3 col-xl-50 col-sm-6 proorder-xl-3',
        bodyClass: 'money',
        color: 'secondary',
        title: 'Revenue',
        rate: '$5.873',
        icon: 'money',
        percent: 3.10
    },
    {
        id: 3,
        divClass: 'col-xxl-3 col-xl-50 col-sm-6 proorder-xl-4',
        bodyClass: 'profit',
        color: 'danger',
        title: 'Profit',
        rate: '70%',
        icon: 'profile',
        percent: 2.3
    },
    {
        id: 4,
        divClass: 'col-xxl-3 col-xl-50 col-sm-6 proorder-xl-5',
        bodyClass: 'invoice-profit',
        color: 'success',
        title: 'Invoices',
        rate: '1.256',
        icon: 'invoice',
        percent: 6.3
    }
];

export const activeTasksData = [
    {
        id: 1,
        title: 'Regina Cooper',
        text: 'Create userflow social application design'
    },
    {
        id: 2,
        title: 'Install Appointment',
        text: 'Homepage design for slimmuch product'
    },
    {
        id: 3,
        title: 'Regina Cooper',
        text: 'Interactive prototype design - web design'
    },
    {
        id: 4,
        title: 'Regina Cooper',
        text: 'Create Application design for topbuzz'
    }
]

export const animateImageList = ['code', 'write', 'chat', 'setting']

export const admissionRatioOption: ApexOptions = {
    series: [
        {
            name: '',
            data: [30, 32.31, 31.47, 30.69, 29.32, 31.65, 31.13, 31.77, 31.79, 31.67, 32.39, 32.63, 32.89, 31.99, 31.23, 31.57, 30.84, 31.07, 31.41, 31.17, 32.37, 32.19, 32.51, 32.37, 32.51, 32.65, 32.64, 32.27, 32.1, 32.91, 33.65, 33.8, 33.92
            ],
        },
    ],
    chart: {
        type: 'area',
        height: 115,
        offsetX: 0,
        toolbar: {
            show: false,
        },
    },
    stroke: {
        width: 2,
        curve: 'straight'
    },
    grid: {
        show: false,
        borderColor: 'var(--light)',
        padding: {
            top: 5,
            right: 0,
            bottom: -30,
            left: 0,
        },
    },
    fill: {
        type: ['gradient'],
        gradient: {
            shade: 'light',
            type: "vertical",
            shadeIntensity: 1,
            gradientToColors: ["#008dab"],
            inverseColors: true,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 100, 100, 100],
        }
    },
    dataLabels: {
        enabled: false,
    },
    colors: ["#008dab"],
    xaxis: {
        labels: {
            show: false,
        },
        tooltip: {
            enabled: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        opposite: false,
        min: 29,
        max: 35,
        logBase: 100,
        tickAmount: 4,
        forceNiceScale: false,
        floating: false,
        decimalsInFloat: undefined,
        labels: {
            show: false,
            offsetX: -12,
            offsetY: -15,
            rotate: 0,
        },
    },
    legend: {
        horizontalAlign: 'left',
    },
    tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, }) {
            return '<div class="apex-tooltip p-2">' + '<span>' + '<span class="bg-primary">' + '</span>' + 'Sales' + '<h3>' + '$' + series[seriesIndex][dataPointIndex] + '<h3/>' + '</span>' + '</div>';
        },
    },
};

export const newCustomersData = [
    {
        id: 1,
        image: '10.jpg',
        name: 'Rachel Green',
        email: 'Rache87@.com',
        product: 'Headphone',
        sale: '564',
        rate: '239'
    },
    {
        id: 2,
        image: '11.jpg',
        name: 'Fran Loain',
        email: 'fran34@.com',
        product: 'Fashion',
        sale: '654',
        rate: '326'
    },
    {
        id: 3,
        image: '12.jpg',
        name: 'Loie Fenter',
        email: 'loie234@.com',
        product: 'Bookshop',
        sale: '347',
        rate: '254.23'
    }
]

export const grossCategoriesData: GrossCategoriesType[] = [
    {
        id: 1,
        image: '10.png',
        product: 'Headphone',
        orderId: '#203565',
        date: '15/02/24',
        amount: '$512',
        status: 'In Stock',
        statusColor: 'primary',
        quantity: '20 PCS'
    },
    {
        id: 2,
        image: '11.png',
        product: 'Asus tuf f15',
        orderId: '#568923',
        date: '30/03/24',
        amount: '$618',
        status: 'Low Stock',
        statusColor: 'success',
        quantity: '03 PCS'
    },
    {
        id: 3,
        image: '12.png',
        product: 'Iphone 13',
        orderId: '#956874',
        date: '20/05/24',
        amount: '$510',
        status: 'In Stock',
        statusColor: 'primary',
        quantity: '01 PCS'
    },
    {
        id: 4,
        image: '13.png',
        product: 'Mi Smart Watch',
        orderId: '#365894',
        date: '11/08/24',
        amount: '$200',
        status: 'Full Stock',
        statusColor: 'warning',
        quantity: '10 PCS'
    },
]

export const grossCategoriesColumns: TableColumn<GrossCategoriesType>[] = [
    {
        name: (
            <FormGroup check>
                <Input type="checkbox" value="" />
                <Label check></Label>
            </FormGroup>),
        sortable: false,
        cell: () => {
            return (
                <FormGroup check>
                    <Input type="checkbox" value="" />
                    <Label check></Label>
                </FormGroup>
            );
        },
        width: '5%'
    },
    {
        name: "Product name",
        selector: (row) => row.product,
        sortable: true,
        cell: (row) => (
            <div className="d-flex">
                <div className="flex-shrink-0"><Image src={dynamicImage(`dashboard-2/product/${row.image}`)} alt="" /></div>
                <div className="flex-grow-1 ms-3">
                    <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/product-list`}>
                        <H6>{row.product}</H6>
                    </Link>
                </div>
            </div>
        )
    },
    {
        name: "Order ID",
        selector: (row) => row.orderId,
        sortable: true,
    },
    {
        name: "Date",
        selector: (row) => row.date,
        sortable: true,
    },
    {
        name: "Amount",
        selector: (row) => row.amount,
        sortable: true,
    },
    {
        name: "Status",
        selector: (row) => row.status,
        sortable: true,
        cell: (row) => <Btn color={row.statusColor}>{row.status}</Btn>,
    },
    {
        name: "Quantity",
        selector: (row) => row.quantity,
        sortable: true,
    },
];

export const revenueChart: ApexOptions = {
    series: [
        {
            name: "Earning",
            data: [78, 45, 60, 78, 78, 45, 25, 50, 60, 60, 78, 40],
        },
        {
            name: "Expense",
            data: [-70, -70, -40, -30, -70, -30, -25, -45, -40, -50, -70, -50],
        },
    ],
    chart: {
        type: "bar",
        height: 330,
        stacked: true,
        toolbar: {
            show: false,
        },
    },
    colors: ["#008dab", "#e87f24"],
    plotOptions: {
        bar: {
            columnWidth: "70%",
        },
    },
    dataLabels: {
        enabled: false,
    },
    legend: {
        show: false,
    },
    stroke: {
        width: 10,
        colors: ["#fff"]
    },
    grid: {
        show: false,
        xaxis: {
            lines: {
                show: true,
            },
        },
        yaxis: {
            lines: {
                show: false,
            },
        },
    },
    xaxis: {
        categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        labels: {
            style: {
                fontSize: "13px",
                colors: "#959595",
                fontFamily: "Lexend, sans-serif",
            },
        },
        axisBorder: {
            show: true,
        },
        axisTicks: {
            show: false,
        },
    },
    responsive: [
        {
            breakpoint: 1501,
            options: {
                plotOptions: {
                    bar: {
                        columnWidth: "90%",
                    },
                },
            },
        },
        {
            breakpoint: 480,
            options: {
                plotOptions: {
                    bar: {
                        columnWidth: "130%",
                    },
                },
            },
        },
    ],
    tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, }) {
            return '<div class="apex-tooltip p-2">' + '<span>' + '<span class="bg-primary">' + '</span>' + 'Earning' + '<h3>' + '$' + series[seriesIndex][dataPointIndex] + '<h3/>' + '</span>' + '</div>';
        },
    },
};

export const companyViewChart: ApexOptions = {
    series: [
        {
            name: "This Month ",
            type: "area",
            data: [215, 260, 360, 420, 320, 280, 360]
        },
        {
            name: "This Month",
            type: "area",
            data: [90, 130, 280, 350, 400, 350, 400],
        },
    ],
    chart: {
        height: 380,
        type: "area",
        zoom: {
            enabled: false,
        },
        toolbar: {
            show: false,
        },
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        width: [3, 3],
        curve: "straight",
        dashArray: [0, 6],
    },
    colors: ["#e87f24", "#008dab"],
    markers: {
        discrete: [{
            seriesIndex: 0,
            dataPointIndex: 0,
            fillColor: "#fff",
            strokeColor: "#e87f24",
            size: 5,
            shape: "circle"
        },
        {
            seriesIndex: 0,
            dataPointIndex: 1,
            fillColor: "#fff",
            strokeColor: "#e87f24",
            size: 5,
            shape: "circle"
        },
        {
            seriesIndex: 0,
            dataPointIndex: 2,
            fillColor: "#fff",
            strokeColor: "#e87f24",
            size: 5,
            shape: "circle"
        },
        {
            seriesIndex: 0,
            dataPointIndex: 3,
            fillColor: "#fff",
            strokeColor: "#e87f24",
            size: 5,
            shape: "circle"
        },
        {
            seriesIndex: 0,
            dataPointIndex: 4,
            fillColor: "#fff",
            strokeColor: "#e87f24",
            size: 5,
            shape: "circle"
        },
        {
            seriesIndex: 0,
            dataPointIndex: 5,
            fillColor: "#fff",
            strokeColor: "#e87f24",
            size: 5,
            shape: "circle"
        },
        {
            seriesIndex: 0,
            dataPointIndex: 6,
            fillColor: "#fff",
            strokeColor: "#e87f24",
            size: 5,
            shape: "circle"
        },
        ],
    },
    xaxis: {
        categories: [
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat",
            "Sun",
        ],
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        labels: {
            style: {
                fontSize: "13px",
                colors: "#959595",
                fontFamily: "Lexend, sans-serif",
            },
        },
    },
    yaxis: {
        labels: {
            formatter: function (val) {
                return val + "" + "k";
            },
            style: {
                fontSize: "14px",
                colors: "$black",
                fontWeight: 500,
                fontFamily: "Lexend, sans-serif",
            },
        },
    },
    fill: {
        colors: ["#e87f24", "#008dab"],
        type: ["gradient", "gradient"],
        gradient: {
            shade: "light",
            type: "vertical",
            opacityFrom: 0.5,
            opacityTo: 0.1,
            stops: [0, 100, 0, 0],
        },
    },
    grid: {
        borderColor: "#f1f1f1",
    },
    legend: {
        show: false,
    },
    responsive: [
        {
            breakpoint: 1200,
            options: {
                chart: {
                    height: 330,
                },
            },
        },
        {
            breakpoint: 480,
            options: {
                plotOptions: {
                    bar: {
                        columnWidth: "150%",
                    },
                },
            },
        },
    ],
    tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, }) {
            return '<div class="apex-tooltip p-2">' + '<span>' + '<span class="bg-primary">' + '</span>' + 'Deliveries' + '<h3>' + '$' + series[seriesIndex][dataPointIndex] + '<h3/>' + '</span>' + '</div>';
        },
    },
};

export const newsUpdateData = [
    {
        id: 1,
        image: '1.png',
        title: 'Wikipedia project application review.',
        text: "Today's newspaper headlines...",
        time: '4hr ago'
    },
    {
        id: 2,
        image: '2.png',
        title: "Develop your company's logo.",
        text: "check out the latest...",
        time: '6hr ago'
    },
    {
        id: 3,
        image: '3.png',
        title: 'Commercial project research',
        text: "Articles in English: Get...",
        time: '8 Jun'
    },
    {
        id: 4,
        image: '4.png',
        title: 'Recruiting in the Department',
        text: "Technology and...",
        time: '23 Jun'
    },
    {
        id: 5,
        image: '5.png',
        title: 'Corporate research on the project',
        text: "Contributions private...",
        time: '25 july'
    }
]

export const goalOverviewChart: ApexOptions = {
    series: [65],
    chart: {
        height: 390,
        type: 'radialBar',
        offsetY: -10,
    },
    plotOptions: {
        radialBar: {
            startAngle: -135,
            endAngle: 135,
            inverseOrder: true,
            hollow: {
                margin: 20,
                size: '65%',
                image: dynamicImage(`logo/chart-logo.png`),
                imageWidth: 80,
                imageHeight: 80,
                imageClipped: false,
                background: '#008dab1a',
                dropShadow: {
                    enabled: false,
                    top: 0,
                    left: 0,
                    blur: 1,
                    opacity: 0.3
                },
            },
            track: {
                opacity: 0.7,
            },
            dataLabels: {
                name: {
                    fontSize: '16px',
                    color: '#000',
                    offsetY: 150
                },
                value: {
                    offsetY: 110,
                    fontSize: '20px',
                    color: "#008dab",
                    formatter: function (val) {
                        return val + "%";
                    }
                },
            },
        }
    },
    responsive: [
        {
            breakpoint: 1600,
            options: {
                chart: {
                    height: 300,
                },
                plotOptions: {
                    radialBar: {
                        hollow: {
                            imageWidth: 60,
                            imageHeight: 60,
                        },
                    },
                },
            },
        },
        {
            breakpoint: 1330,
            options: {
                chart: {
                    height: 250,
                },
                plotOptions: {
                    dataLabels: {
                        show: false,
                    },
                },
            },
        },
        {
            breakpoint: 1200,
            options: {
                chart: {
                    height: 380,
                },
                plotOptions: {
                    dataLabels: {
                        show: false,
                    },
                },
            },
        },
        {
            breakpoint: 360,
            options: {
                chart: {
                    height: 300,
                },
                plotOptions: {
                    dataLabels: {
                        show: false,
                    },
                },
            },
        },
    ],
    labels: ['Goal In Progress'],
    colors: ["#008dab"],
};

export const totalLikesOption: ApexOptions = {
    series: [
        {
            name: 'series2',
            data: [0, 40, 25, 80, 35, 40, 38, 50, 35, 70, 40, 100, 20],
        },
    ],
    chart: {
        height: 105,
        type: 'area',
        sparkline: {
            enabled: true,
        },
    },
    dataLabels: {
        enabled: false,
    },
    colors: ["#008dab"],
    fill: {
        type: ['gradient'],
        gradient: {
            shade: 'light',
            type: "vertical",
            shadeIntensity: 1,
            gradientToColors: ["#008dab"],
            inverseColors: true,
            opacityFrom: 0.6,
            opacityTo: 0,
            stops: [0, 100, 100, 100],
        }
    },
    stroke: {
        curve: 'smooth',
        width: 2,
    },
    tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, }) {
            return '<div class="apex-tooltip p-2">' + '<span>' + '<span class="bg-primary">' + '</span>' + 'Total-Sales' + '<h3>' + '$' + series[seriesIndex][dataPointIndex] + '<h3/>' + '</span>' + '</div>';
        },
    },
};

export const visitorChart: ApexOptions = {
    series: [
        {
            name: 'series2',
            data: [60, 50, 114, 65, 56, 93, 50, 72, 60, 50, 114, 65, 56],
        },
    ],
    colors: ["#e87f2433", "#e87f2433", "#e87f2433", "#e87f2433", "#e87f24", "#e87f24", "#e87f24", "#e87f24", "#e87f24", "#e87f2433", "#e87f2433", "#e87f2433", "#e87f2433"],
    chart: {
        height: 105,
        type: 'bar',
        offsetY: 25,
        sparkline: {
            enabled: true,
        },
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        curve: 'smooth',
    },
    plotOptions: {
        bar: {
            borderRadius: 10,
            distributed: true,
            barHeight: '35%',
            dataLabels: {
                position: 'top',
            },
        }
    },
    tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, }) {
            return '<div class="apex-tooltip p-2">' + '<span>' + '<span class="bg-primary">' + '</span>' + 'Total-Visitors' + '<h3>' + '$' + series[seriesIndex][dataPointIndex] + '<h3/>' + '</span>' + '</div>';
        },
    },
};

export const totalSaleData = [
    {
        id: 1,
        color: 'primary',
        icon: 'fill-Buy',
        rate: '65.340',
        title: 'Total Sales',
        percent: '5.8',
        chart: {
            ...totalLikesOption,
            series: totalLikesOption.series,
            type: totalLikesOption.chart?.type,
            height: totalLikesOption.chart?.height,
        },
    },
    {
        id: 2,
        color: 'secondary',
        icon: 'user',
        rate: '54.568',
        title: 'Total Visitor',
        percent: '9.2',
        chart: {
            ...visitorChart,
            series: visitorChart.series,
            type: visitorChart.chart?.type,
            height: visitorChart.chart?.height,
        },
    }
]

export const sellingProductData = [
    {
        id: 1,
        image: '1.png',
        name: 'Nike Sports NK',
        subText: 'Free delivery',
        customer: 'Rodney Cannon',
        email: 'rodney@gmail.com',
        progressValue: 80,
        progressColor: 'primary',
        total: '18.00',
        shipping: '512.00'
    },
    {
        id: 2,
        image: '2.png',
        name: 'Women Bag',
        subText: '$83.97 delivery',
        customer: 'Mike franklin',
        email: 'mike@gmail.com',
        progressValue: 60,
        progressColor: 'secondary',
        total: '62.00',
        shipping: '325.00'
    },
    {
        id: 3,
        image: '3.png',
        name: 'Sunglasses',
        subText: 'Free delivery',
        customer: 'Louis Franklin',
        email: 'louis@gmail.com',
        progressValue: 50,
        progressColor: 'success',
        total: '51.00',
        shipping: '956.00'
    }
]

export const saleChart: ApexOptions = {
    series: [
        {
            data: [30, 20, 25, 15, 35, 38, 49, 38, 45, 35, 55, 57],
        },
    ],
    chart: {
        width: 180,
        height: 120,
        type: "line",
        toolbar: {
            show: false,
        },
        offsetY: 10,
        dropShadow: {
            enabled: false,
        },
    },
    grid: {
        show: false,
    },
    colors: ["#008dab"],
    stroke: {
        width: 2,
        curve: "smooth",
    },
    labels: [
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "jul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec"
    ],
    markers: {
        size: 0,
    },
    xaxis: {
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        labels: {
            show: false,
        },
        tooltip: {
            enabled: false,
        },
    },
    yaxis: {
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        labels: {
            show: false,
        },
    },
    legend: {
        show: false,
    },
    tooltip: {
        marker: {
            show: false,
        },
        x: {
            show: false,
        },
    },
    responsive: [
        {
            breakpoint: 1790,
            options: {
                chart: {
                    width: 150,
                },
            },
        },
        {
            breakpoint: 1660,
            options: {
                chart: {
                    width: 120,
                },
            },
        },
        {
            breakpoint: 1520,
            options: {
                chart: {
                    width: 100,
                },
            },
        },
        {
            breakpoint: 1200,
            options: {
                chart: {
                    width: 180,
                    height: 120,
                    offsetX: -10,
                },
            },
        },
        {
            breakpoint: 992,
            options: {
                chart: {
                    width: 130,
                    height: 120,
                    offsetX: 10,
                },
            },
        },
        {
            breakpoint: 768,
            options: {
                chart: {
                    width: 180,
                    height: 120,
                    offsetX: 0,
                },
            },
        },
        {
            breakpoint: 380,
            options: {
                chart: {
                    width: 110,
                    height: 120,
                    offsetX: 0,
                },
            },
        },
    ],
}

export const orderChart: ApexOptions = {
    series: [
        {
            data: [30, 20, 28, 20, 28, 17, 50, 45, 63, 52, 66, 30],
        },
    ],
    chart: {
        width: 180,
        height: 120,
        type: "line",
        toolbar: {
            show: false,
        },
        offsetY: 10,
        dropShadow: {
            enabled: false,
        },
    },
    grid: {
        show: false,
    },
    colors: ["#008dab"],
    stroke: {
        width: 2,
        curve: "smooth",
    },
    labels: [
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "jul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec"
    ],
    markers: {
        size: 0,
    },
    xaxis: {
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        labels: {
            show: false,
        },
        tooltip: {
            enabled: false,
        },
    },
    yaxis: {
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        labels: {
            show: false,
        },
    },
    legend: {
        show: false,
    },
    tooltip: {
        marker: {
            show: false,
        },
        x: {
            show: false,
        },
    },
    responsive: [
        {
            breakpoint: 1790,
            options: {
                chart: {
                    width: 150,
                },
            },
        },
        {
            breakpoint: 1660,
            options: {
                chart: {
                    width: 120,
                },
            },
        },
        {
            breakpoint: 1520,
            options: {
                chart: {
                    width: 100,
                },
            },
        },
        {
            breakpoint: 1200,
            options: {
                chart: {
                    width: 180,
                    height: 120,
                    offsetX: -10,
                },
            },
        },
        {
            breakpoint: 992,
            options: {
                chart: {
                    width: 130,
                    height: 120,
                    offsetX: 10,
                },
            },
        },
        {
            breakpoint: 768,
            options: {
                chart: {
                    width: 180,
                    height: 120,
                    offsetX: 0,
                },
            },
        },
        {
            breakpoint: 380,
            options: {
                chart: {
                    width: 110,
                    height: 120,
                    offsetX: 0,
                },
            },
        },
    ],
}

export const deliveryChart: ApexOptions = {
    series: [
        {
            data: [55, 30, 40, 35, 50, 35, 32, 10, 60, 15, 20, 30],
        },
    ],
    chart: {
        width: 180,
        height: 120,
        type: "line",
        toolbar: {
            show: false,
        },
        offsetY: 10,
        dropShadow: {
            enabled: false,
        },
    },
    grid: {
        show: false,
    },
    colors: ["#da9817"],
    stroke: {
        width: 2,
        curve: "smooth",
    },
    labels: [
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "jul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec"
    ],
    markers: {
        size: 0,
    },
    xaxis: {
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        labels: {
            show: false,
        },
        tooltip: {
            enabled: false,
        },
    },
    yaxis: {
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        labels: {
            show: false,
        },
    },
    legend: {
        show: false,
    },
    tooltip: {
        marker: {
            show: false,
        },
        x: {
            show: false,
        },
    },
    responsive: [
        {
            breakpoint: 1790,
            options: {
                chart: {
                    width: 150,
                },
            },
        },
        {
            breakpoint: 1660,
            options: {
                chart: {
                    width: 120,
                },
            },
        },
        {
            breakpoint: 1520,
            options: {
                chart: {
                    width: 100,
                },
            },
        },
        {
            breakpoint: 1200,
            options: {
                chart: {
                    width: 180,
                    height: 120,
                    offsetX: -10,
                },
            },
        },
        {
            breakpoint: 992,
            options: {
                chart: {
                    width: 130,
                    height: 120,
                    offsetX: 10,
                },
            },
        },
        {
            breakpoint: 768,
            options: {
                chart: {
                    width: 180,
                    height: 120,
                    offsetX: 0,
                },
            },
        },
        {
            breakpoint: 380,
            options: {
                chart: {
                    width: 110,
                    height: 120,
                    offsetX: 0,
                },
            },
        },
    ],
}

export const progressItemData = [
    {
        id: 1,
        title: 'Online Order',
        arrowColor: 'danger',
        arrowIcon: 'arrow-chart',
        percent: '-6.3',
        rate: '16,287',
        color: 'primary',
        icon: 'basket',
        value: 25,
        chart: {
            ...saleChart,
            series: saleChart.series,
            type: saleChart.chart?.type,
            height: saleChart.chart?.height,
        },
    },
    {
        id: 2,
        title: 'Offline Order',
        arrowColor: 'success',
        arrowIcon: 'arrow-chart-up',
        percent: '+8.3',
        rate: '35,235',
        color: 'secondary',
        icon: 'delivery',
        value: 15,
        chart: {
            ...orderChart,
            series: orderChart.series,
            type: orderChart.chart?.type,
            height: orderChart.chart?.height,
        },
    },
    {
        id: 3,
        title: 'Total Revenue',
        arrowColor: 'warning',
        arrowIcon: 'arrow-chart-yellow',
        percent: '+3.5',
        rate: '45,956',
        color: 'warning',
        icon: 'increased',
        value: 20,
        chart: {
            ...deliveryChart,
            series: deliveryChart.series,
            type: deliveryChart.chart?.type,
            height: deliveryChart.chart?.height,
        },
    }
]